import KEY_CODES from '../components/userDocuments/editDocument/editJournal/constants/keyCodes';

export default [
  KEY_CODES.DOWN,
  KEY_CODES.UP,
  KEY_CODES.LEFT,
  KEY_CODES.RIGHT,
  KEY_CODES.TAB,
];
